import { render, staticRenderFns } from "./mediaFocus.vue?vue&type=template&id=5bfbd493&scoped=true&"
import script from "./mediaFocus.vue?vue&type=script&lang=js&"
export * from "./mediaFocus.vue?vue&type=script&lang=js&"
import style0 from "./mediaFocus.vue?vue&type=style&index=0&id=5bfbd493&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfbd493",
  null
  
)

export default component.exports